import { render } from "./lgu-approval.vue?vue&type=template&id=35e52f27"
import script from "./lgu-approval.vue?vue&type=script&lang=js"
export * from "./lgu-approval.vue?vue&type=script&lang=js"

import exportComponent from "/home/staging-tcms.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__